import React from 'react';
import { TbMenu2 } from 'react-icons/tb';
import icLogo from '../static/logo-dark.svg';
import { wrap, menuButton, logos } from './style';

interface Props {
  onOpenMenu?: () => void;
}

function Header({ onOpenMenu }: Props) {
  return (
    <header css={wrap}>
      <button
        type="button"
        css={menuButton}
        onClick={onOpenMenu}
        aria-label="메뉴 열기"
      >
        <TbMenu2 size={22} />
      </button>
      <div css={logos}>
        <img src={icLogo} alt="logo" />
      </div>
    </header>
  );
}

export default Header;
